import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { OpenDialogAddEditResourceComponent } from 'app/components/dialog/open-dialog-add-edit-resource/open-dialog-add-edit-resource.component';
import { ClubRessource } from 'app/shared/models/class/resource/resource';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-admin-resource-club',
  templateUrl: './admin-resource-club.component.html',
  styleUrls: ['./admin-resource-club.component.scss']
})
export class AdminResourceClubComponent extends SubscriptionBaseComponent implements OnInit {

  displayedColumns: string[] = ['lastname', 'firstname', 'pseudo', 'isActive', 'edit'];
  dataSource: MatTableDataSource<ClubRessource>;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;

  color: ThemePalette = 'primary';
  resources: ClubRessource[];
  userConnected: any;
  clubCode: any;

  constructor(
    private dialog: MatDialog,
    private clubService: ClubService,
    private dataService: DataService,
    private authService: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private faIconService: FaiconService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initComponent();
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  addOrEditResource(action: string, resource?: any): void {

    const dialogRef = this.dialog.open(OpenDialogAddEditResourceComponent, {
      data: { action, resource },
      width: '50%'
    });

    dialogRef.afterClosed().subscribe(res => {

      if (res) {
        this.dataService.clubActiveResources$.next(res.data);
        this.router.navigate(['/admin/resource'], { queryParams: { clubCode: res.data } });
      }
      this.getResources(this.clubCode);
    });
  }

  activeOrDeactiveResource(): void {

  }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private async initComponent() {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = await this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;
    this.getResources(this.clubCode);

    // if (this.userConnected.role === 'club') {
    //   this.clubCode = this.userConnected.club_code;
    // }
    // this.getResources();
  }

  private getResources(clubCode: string) {
    this.clubService.getAllRessourceByClub(clubCode).subscribe({
      next: resources => {
        this.dataSource = new MatTableDataSource<ClubRessource>(resources);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.length = resources.length;
        this.dataService.updateRessources$.next(false);
      }
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.valueFilterResource$.subscribe({
          next: valueFilterResource => {
            this.applyFilter(valueFilterResource);
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.updateRessources$.subscribe({
          next: update => {
            if (update) {
              this.getResources(this.clubCode);
            }
          }
        })
      );
  }


}
